import React from 'react';
import { Card, CardContent, Typography, Box, Chip, IconButton } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import StarIcon from '@mui/icons-material/Star';
import DeleteIcon from '@mui/icons-material/Delete';

const RestaurantCard = ({ restaurant, onRestaurantClick, onRestaurantDelete }) => {
  const handleClick = () => {
    onRestaurantClick(restaurant);
  };

  const handleDelete = (event) => {
    event.stopPropagation(); // Prevent card click when delete button is clicked
    onRestaurantDelete(restaurant);
  };

  return (
    <Card 
      sx={{ 
        cursor: 'pointer',
        position: 'relative',
        '&:hover': {
          boxShadow: 3,
          transform: 'translateY(-2px)',
          transition: 'all 0.2s ease-in-out'
        }
      }}
      onClick={handleClick}
    >
      {/* Delete Button - positioned absolutely in top right */}
      <IconButton
        onClick={handleDelete}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          '&:hover': {
            backgroundColor: '#ffcdd2',
            color: '#d32f2f'
          }
        }}
        size="small"
      >
        <DeleteIcon fontSize="small" />
      </IconButton>

      <CardContent>
        <Typography variant="h6" component="div" gutterBottom>
          {restaurant.name}
        </Typography>
        
        {restaurant.cuisine_type && (
          <Chip 
            label={restaurant.cuisine_type} 
            size="small" 
            color="primary" 
            sx={{ mb: 1 }}
          />
        )}

        {restaurant.address && (
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <LocationOnIcon fontSize="small" color="action" sx={{ mr: 0.5 }} />
            <Typography variant="body2" color="text.secondary">
              {restaurant.address}
            </Typography>
          </Box>
        )}

        {restaurant.phone && (
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <PhoneIcon fontSize="small" color="action" sx={{ mr: 0.5 }} />
            <Typography variant="body2" color="text.secondary">
              {restaurant.phone}
            </Typography>
          </Box>
        )}

        {restaurant.rating && (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <StarIcon fontSize="small" color="warning" sx={{ mr: 0.5 }} />
            <Typography variant="body2" color="text.secondary">
              {restaurant.rating}/5
            </Typography>
          </Box>
        )}

        {restaurant.notes && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1, fontStyle: 'italic' }}>
            {restaurant.notes}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default RestaurantCard;